"use client";

import { c as _c } from "react/compiler-runtime";
import React from "react";
import { SectionHeader, MatchListBlock, type MatchListItem } from "fansunited-sports-ui";
import type { FUSportsMatch } from "fansunited-data-layer";
import { usePlayerPageData } from "../context/PlayerPageDataContext";
import { useLabels } from "@/lib/labels/LabelsProvider";
import { useNavigation } from "@/lib/navigation/NavigationProvider";
import { formatDateDDMM } from "@/utilities/formatting/date";
export const PlayerRecentForm: React.FC = () => {
  const $ = _c(68);
  const {
    recentStats,
    matchIdMap
  } = usePlayerPageData();
  const labels = useLabels().playerPage.recentForm;
  const nav = useNavigation();
  if (!recentStats?.matches || recentStats.matches.length === 0) {
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
      t0 = {
        typography: {
          name: "text-sm uppercase font-semibold text-foreground"
        }
      };
      $[0] = t0;
    } else {
      t0 = $[0];
    }
    let t1;
    if ($[1] !== labels.title) {
      t1 = {
        name: labels.title,
        styles: t0
      };
      $[1] = labels.title;
      $[2] = t1;
    } else {
      t1 = $[2];
    }
    let t2;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
      t2 = {
        container: "mb-2"
      };
      $[3] = t2;
    } else {
      t2 = $[3];
    }
    let t3;
    if ($[4] !== t1) {
      t3 = <SectionHeader entity={t1} styles={t2} />;
      $[4] = t1;
      $[5] = t3;
    } else {
      t3 = $[5];
    }
    let t4;
    if ($[6] !== labels.noRecentMatches) {
      t4 = <div className="bg-card rounded-lg p-6"><p className="text-center text-muted-foreground">{labels.noRecentMatches}</p></div>;
      $[6] = labels.noRecentMatches;
      $[7] = t4;
    } else {
      t4 = $[7];
    }
    let t5;
    if ($[8] !== t3 || $[9] !== t4) {
      t5 = <div>{t3}{t4}</div>;
      $[8] = t3;
      $[9] = t4;
      $[10] = t5;
    } else {
      t5 = $[10];
    }
    return t5;
  }
  const matchCount = recentStats.matches.length;
  let t0;
  if ($[11] !== matchIdMap || $[12] !== nav || $[13] !== recentStats.matches) {
    let t1;
    if ($[15] !== matchIdMap || $[16] !== nav) {
      t1 = match => {
        const kickoffDate = new Date(match.timing.kickoffTime);
        const nativeMatchId = matchIdMap[match.id] ?? match.id;
        const isFinished = match.status?.type === "FINISHED";
        return {
          match: {
            id: nativeMatchId,
            link: nav.match(nativeMatchId),
            competitorOne: {
              id: match.competitorOne.id,
              name: match.competitorOne.name,
              shortName: match.competitorOne.shortName,
              logo: {
                url: match.competitorOne.assets?.logo || "",
                alt: match.competitorOne.name
              },
              ...(isFinished && match.score && {
                score: {
                  main: match.score.competitorOne || "0"
                }
              })
            },
            competitorTwo: {
              id: match.competitorTwo.id,
              name: match.competitorTwo.name,
              shortName: match.competitorTwo.shortName,
              logo: {
                url: match.competitorTwo.assets?.logo || "",
                alt: match.competitorTwo.name
              },
              ...(isFinished && match.score && {
                score: {
                  main: match.score.competitorTwo || "0"
                }
              })
            },
            status: isFinished ? "final" : "scheduled",
            metadata: {
              competition: match.competition?.name || "",
              time: formatDateDDMM(kickoffDate)
            }
          }
        };
      };
      $[15] = matchIdMap;
      $[16] = nav;
      $[17] = t1;
    } else {
      t1 = $[17];
    }
    t0 = recentStats.matches.map(t1);
    $[11] = matchIdMap;
    $[12] = nav;
    $[13] = recentStats.matches;
    $[14] = t0;
  } else {
    t0 = $[14];
  }
  const matchItems = t0;
  let t1;
  if ($[18] !== labels.appearances || $[19] !== recentStats.appearances) {
    t1 = {
      label: labels.appearances,
      value: recentStats.appearances
    };
    $[18] = labels.appearances;
    $[19] = recentStats.appearances;
    $[20] = t1;
  } else {
    t1 = $[20];
  }
  let t2;
  if ($[21] !== labels.goals || $[22] !== recentStats.goals) {
    t2 = {
      label: labels.goals,
      value: recentStats.goals
    };
    $[21] = labels.goals;
    $[22] = recentStats.goals;
    $[23] = t2;
  } else {
    t2 = $[23];
  }
  let t3;
  if ($[24] !== labels.assists || $[25] !== recentStats.assists) {
    t3 = {
      label: labels.assists,
      value: recentStats.assists
    };
    $[24] = labels.assists;
    $[25] = recentStats.assists;
    $[26] = t3;
  } else {
    t3 = $[26];
  }
  let t4;
  if ($[27] !== labels.minutes || $[28] !== recentStats.minutes) {
    t4 = {
      label: labels.minutes,
      value: recentStats.minutes
    };
    $[27] = labels.minutes;
    $[28] = recentStats.minutes;
    $[29] = t4;
  } else {
    t4 = $[29];
  }
  let t5;
  if ($[30] !== labels.yellowCards || $[31] !== recentStats.yellowCards) {
    t5 = {
      label: labels.yellowCards,
      value: recentStats.yellowCards
    };
    $[30] = labels.yellowCards;
    $[31] = recentStats.yellowCards;
    $[32] = t5;
  } else {
    t5 = $[32];
  }
  let t6;
  if ($[33] !== labels.redCards || $[34] !== recentStats.redCards) {
    t6 = {
      label: labels.redCards,
      value: recentStats.redCards
    };
    $[33] = labels.redCards;
    $[34] = recentStats.redCards;
    $[35] = t6;
  } else {
    t6 = $[35];
  }
  let t7;
  if ($[36] !== t1 || $[37] !== t2 || $[38] !== t3 || $[39] !== t4 || $[40] !== t5 || $[41] !== t6) {
    t7 = [t1, t2, t3, t4, t5, t6];
    $[36] = t1;
    $[37] = t2;
    $[38] = t3;
    $[39] = t4;
    $[40] = t5;
    $[41] = t6;
    $[42] = t7;
  } else {
    t7 = $[42];
  }
  const statItems = t7;
  let t8;
  if ($[43] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = {
      typography: {
        name: "text-sm uppercase font-semibold text-foreground"
      }
    };
    $[43] = t8;
  } else {
    t8 = $[43];
  }
  let t9;
  if ($[44] !== labels.title) {
    t9 = {
      name: labels.title,
      styles: t8
    };
    $[44] = labels.title;
    $[45] = t9;
  } else {
    t9 = $[45];
  }
  let t10;
  if ($[46] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = {
      container: "mb-2"
    };
    $[46] = t10;
  } else {
    t10 = $[46];
  }
  let t11;
  if ($[47] !== t9) {
    t11 = <SectionHeader entity={t9} styles={t10} />;
    $[47] = t9;
    $[48] = t11;
  } else {
    t11 = $[48];
  }
  let t12;
  if ($[49] === Symbol.for("react.memo_cache_sentinel")) {
    t12 = {
      matchScoreStyles: {
        typography: {
          teamName: "text-sm lg:text-md font-semibold"
        },
        logoSize: "lg"
      },
      divider: {
        color: "divide-foreground/10"
      }
    };
    $[49] = t12;
  } else {
    t12 = $[49];
  }
  let t13;
  if ($[50] !== matchItems) {
    t13 = <div className="p-3"><MatchListBlock variant="teamResults" items={matchItems} styles={t12} /></div>;
    $[50] = matchItems;
    $[51] = t13;
  } else {
    t13 = $[51];
  }
  let t14;
  if ($[52] !== labels.aggregateLabel || $[53] !== matchCount) {
    t14 = labels.aggregateLabel.replace("{count}", String(matchCount));
    $[52] = labels.aggregateLabel;
    $[53] = matchCount;
    $[54] = t14;
  } else {
    t14 = $[54];
  }
  let t15;
  if ($[55] !== t14) {
    t15 = <p className="text-xs text-muted-foreground mb-2">{t14}</p>;
    $[55] = t14;
    $[56] = t15;
  } else {
    t15 = $[56];
  }
  let t16;
  if ($[57] !== statItems) {
    t16 = <div className="grid grid-cols-3 sm:grid-cols-6 gap-3">{statItems.map(_temp)}</div>;
    $[57] = statItems;
    $[58] = t16;
  } else {
    t16 = $[58];
  }
  let t17;
  if ($[59] !== t15 || $[60] !== t16) {
    t17 = <div className="border-t border-muted px-3 py-3">{t15}{t16}</div>;
    $[59] = t15;
    $[60] = t16;
    $[61] = t17;
  } else {
    t17 = $[61];
  }
  let t18;
  if ($[62] !== t13 || $[63] !== t17) {
    t18 = <div className="bg-card rounded-lg shadow-md overflow-hidden">{t13}{t17}</div>;
    $[62] = t13;
    $[63] = t17;
    $[64] = t18;
  } else {
    t18 = $[64];
  }
  let t19;
  if ($[65] !== t11 || $[66] !== t18) {
    t19 = <div>{t11}{t18}</div>;
    $[65] = t11;
    $[66] = t18;
    $[67] = t19;
  } else {
    t19 = $[67];
  }
  return t19;
};
function _temp(item) {
  return <div key={item.label} className="text-center"><p className="text-lg font-bold text-foreground">{item.value ?? 0}</p><p className="text-xs text-muted-foreground">{item.label}</p></div>;
}